import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';

export const AuthCheck = () => {
  const { asPath } = useRouter();
  const { getBaseUser } = useAuth();

  useEffect(() => {
    getBaseUser();
  }, [asPath]);

  return null;
};
